export const clamp = (num, min, max) =>
  Math.min(Math.max(num, min), max);

export const round = (value, precision = 100) =>
  Math.round(value * precision) / precision;

export const within = (value, max, distance) =>
  value > max - distance && value < max + distance;
